module.exports = __webpack_public_path__ + "img/docx.a117da03.svg";